import React, { useEffect, createContext, useState, useRef } from 'react';
import "vanilla-cookieconsent/dist/cookieconsent.css";
import * as CookieConsent from "vanilla-cookieconsent";

export const CookieContext = createContext(null);

const CookieProvider = ({ children }) => {
    useEffect(() => {
        CookieConsent.run({
            categories: {
                necessary: { enabled: true, readOnly: true },
                functional: { enabled: true, readOnly: true } // force functional cookies always enabled
            },
            language: {
                default: 'de',
                translations: {
                    de: {
                        consentModal: {
                            title: "Wir verwenden Cookies 🍪",
                            description: "Unsere Cookies sind technisch notwendig, um Ihnen die Möglichkeit zu bieten, eine Spende zu tätigen.",
                            acceptAllBtn: "Alles klar!",
                            showPreferencesBtn: "Weitere Informationen"
                        },
                        preferencesModal: {
                            title: "Cookie-Einstellungen verwalten",
                            acceptAllBtn: "Alle akzeptieren",
                            savePreferencesBtn: "Auswahl speichern",
                            closeIconLabel: "Schließen",
                            sections: [
                                {
                                    title: "Weitere Informationen",
                                    description: "Unsere Website verwendet keine Tracking-Cookies oder Werbeanzeigen. Es werden außerdem keinerlei Analysedaten gesammelt."
                                },
                                {
                                    title: "Technisch notwendige Cookies",
                                    description: "Diese Cookies sind unerlässlich für den Betrieb unserer Website. Sie ermöglichen grundlegende Funktionen wie die Speicherung Ihres Login-Tokens und die Sicherheit der Website.",
                                    linkedCategory: "necessary"
                                },
                                {
                                    title: "Funktionale Cookies",
                                    description: "Diese Cookies sind zwingend erforderlich, damit Sie Spenden tätigen können.",
                                    linkedCategory: "functional"
                                }
                            ]
                        }
                    }
                }
            }
        });

       
    }, []);

    return (
        <></>
    );
};

export default CookieProvider;
